import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "price" }
const _hoisted_2 = /*#__PURE__*/_createVNode("sup", null, "$", -1)
const _hoisted_3 = { class: "month" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = { class: "button" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Buy")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_card = _resolveComponent("a-card")

  return (_openBlock(), _createBlock(_component_a_card, {
    title: _ctx.database.name,
    class: "card-database gx-card-widget"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(_toDisplayString(_ctx.database.price), 1 /* TEXT */)
      ]),
      _createVNode("div", _hoisted_3, [
        (_ctx.database.months === 1)
          ? (_openBlock(), _createBlock("span", _hoisted_4, "per month"))
          : _createCommentVNode("", true),
        (_ctx.database.months > 1)
          ? (_openBlock(), _createBlock("span", _hoisted_5, "for " + _toDisplayString(_ctx.database.months) + " months", 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("ul", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.database.description, (des) => {
            return (_openBlock(), _createBlock("li", null, [
              _createVNode(_component_CheckCircleFilled, { style: { fontSize: '16px', color: '#00cc37' } }),
              _createTextVNode(" " + _toDisplayString(des), 1 /* TEXT */)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.buyButton
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}